import React from 'react';

const renderSuggestion = suggestion => (
    <div>
        {suggestion.name}
    </div>
);
export default renderSuggestion;



// WEBPACK FOOTER //
// ./src/components/renderSuggestion.js